import { IconButton } from "@mui/material";
import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, greyMui } from "@ryde/theme";

export const AuditLogMetadataLabelsStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "audit-log-metadata-labels-styled",
  },
)`
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
`;

export const AuditLogTraceIdBadgeStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "audit-log-trace-id-badge-styled",
})`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px 4px 8px;
  border-radius: 9px;
  border: 1px solid ${greyMui._300};
  background-color: ${greyMui._50};
  color: ${greyMui._700};
  font-size: inherit;
  font-weight: 500;
  max-width: min(100%, 138px);

  .audit-log-trace-id-badge__text {
    display: inline-flex;
    align-items: center;
    min-width: 0;
    max-width: 104px;
    line-height: 1.3;
    cursor: default;
  }

  .audit-log-trace-id-badge__label {
    flex-shrink: 0;
    margin-inline-end: 4px;
  }

  .audit-log-trace-id-badge__value {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
  }
`;

export const AuditLogTraceIdCopyButtonStyled = styled(
  IconButton,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "audit-log-trace-id-copy-button-styled",
})`
  && {
    flex-shrink: 0;
    padding: 2px;
    color: ${blueGreyMui._500};

    &:hover {
      color: ${blueGreyMui._700};
      background-color: ${greyMui._200};
    }

    .MuiSvgIcon-root {
      font-size: 14px;
    }
  }
`;
